import {notification} from 'antd';
import { useJwt } from "react-jwt";
import { useParams } from "react-router-dom";

 

export function upperCaseFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

 
export function openNotification (placement, msg, descrip, type) {
  type = type || 'info';

  notification[type]({
    message: msg,
    description: descrip,
    placement,
    duration: 5,
  });

  // if(type === 'info'){
  //   notification.info({
  //     message: msg,
  //     description: descrip,
  //     placement,
  //     duration: 5,
  //   });
  // }
  // if(type === 'error'){

  // }
  
};

export function lowerCaseAllWordsExceptFirstLetters(string) {
  return string.replace(/\w\S*/g, function (word) {
    return word.charAt(0) + word.slice(1).toLowerCase();
  });
}
export function removeStartingZero(str) {
  if (str[0] === "0") {
    str = str.slice(1, str.length);
    return str;
  }
  return str;
}

// make it a global utility function
// this function targets only two date formats : (YYYY-MM-DD), (MM-DD-YYYY)
export function getDateFormat(dateString) {
  if (typeof dateString === "object") {
    dateString = dateString._i;
  }
  let position = dateString.indexOf("-");
  if (position === 2) {
    return "MM-DD-YYYY";
  } else if (position === 4) {
    return "YYYY-MM-DD";
  } else {
    return "";
  }
}

export function getGeoStatusColor(status) {
  var color;
  if (status === 0) {
    color = "red";
  } else if (status === 1) {
    color = "rgb(126, 212, 130)"; // green
  } else if (status === 2) {
    color = "orange";
  } else {
    color = "";
  }
  return color;
}

export function getGeoStatusText(status) {
  var text = "";
  if (status === 0) {
    text = "Lat/Long does not exist.";
  } else if (status === 1) {
    text = "Lat/Long exists for this location.";
  } else if (status === 2) {
    text = "Lat/Long is too far from company location.";
  } else {
    text = "";
  }
  return text;
}

export function getCompanyName() {
  let igKey = localStorage.getItem("ig_key");
  if (igKey) {
    let igKeyObject = JSON.parse(igKey);
    return igKeyObject.company_name;
  }
  return null;
}

export function getChannelId(view) {
  let channelId = null;
  let igKey = localStorage.getItem("ig_key");
  if (igKey) {
    let igKeyObject = JSON.parse(igKey);
    var companyId = igKeyObject.company_id;
    if (companyId && view) {
      channelId = `${companyId}_channel_${view}`;
    }
  }
  return channelId;
}

// Utility Function to set the Initial Local Storage
export function setIgMultipleInstancesLocalStorage(
  filterObj,
  StorageObjectMultipleInstancesFilters,
  ...arg
) {
  StorageObjectMultipleInstancesFilters[arg[0]] = filterObj;
  localStorage.setItem(
    "ig_multiple_instances_filters",
    JSON.stringify(StorageObjectMultipleInstancesFilters)
  );
  console.log("Printing Storage Object", StorageObjectMultipleInstancesFilters);
}

export function GetListId(optionsList, value) {
  let list_id = null;

  optionsList.forEach((item) => {
    if (item.value === value) {
      list_id = item.list_id;
       
    }
  });

  return list_id;
}
